import { __TypeOfOrderEnum } from "../initial/initial.interface";

export function extractStateEnumText(state: __TypeOfOrderEnum) {
    switch (state) {
        case __TypeOfOrderEnum.buy:
            return 'خرید';
        case __TypeOfOrderEnum.sell:
            return 'فروش';
        default:
            return 'تبادل';
    }
}